import React from 'react'
import Svg, { Circle, ClipPath, Defs, Ellipse, G, Path, SvgProps } from 'react-native-svg'

import { useTheme } from 'styled-components/native'

import { tID } from '../../utils/utils'

// useId is available in React 18 but @types/react is locked to v17
const useId = (React as any).useId as () => string

const VIEWBOX_WIDTH = 83
const VIEWBOX_HEIGHT = 44

/**
 * Outlined person in a circle next to a bulleted list, used for client profile / questionnaire content.
 */
export const ProfileListIcon = ({ width = VIEWBOX_WIDTH, fillColor, ...rest }: ProfileListIconProps & SvgProps) => {
  const { colors } = useTheme()
  const fill = fillColor || colors.iconDefault
  // Clip ids are document-global on web; scope this one to the instance.
  const clipId = `profile-list-icon-${useId()}`

  return (
    <Svg
      width={width}
      height={(width * VIEWBOX_HEIGHT) / VIEWBOX_WIDTH}
      viewBox={`0 0 ${VIEWBOX_WIDTH} ${VIEWBOX_HEIGHT}`}
      fill='none'
      testID={tID('ProfileListIcon')}
      {...rest}
    >
      <Defs>
        <ClipPath id={clipId}>
          <Circle cx='21' cy='21' r='21' />
        </ClipPath>
      </Defs>
      <G transform='translate(1, 1)'>
        <Circle cx='21' cy='21' r='21' stroke={fill} strokeWidth='2' />
        <G clipPath={`url(#${clipId})`} stroke={fill} strokeWidth='2'>
          <G transform='translate(5.6, 9)'>
            <Circle cx='15.35' cy='7.35' r='7.35' />
            <Path d='M1,38 L30.5,38 L30.5,29.1999998 C30.5,23.5666955 25.9333045,19 20.3000002,19 L11.1999998,19 C5.56669547,19 1,23.5666955 1,29.1999998 L1,38 Z' />
          </G>
        </G>
        <G transform='translate(52, 9)' stroke={fill}>
          <Ellipse
            strokeWidth='0.699999988'
            fill={fill}
            cx='2.07142857'
            cy='2.11764706'
            rx='2.07142857'
            ry='2.11764706'
          />
          <Ellipse strokeWidth='0.699999988' fill={fill} cx='2.07142857' cy='12' rx='2.07142857' ry='2.11764706' />
          <Ellipse
            strokeWidth='0.699999988'
            fill={fill}
            cx='2.07142857'
            cy='22.1176471'
            rx='2.07142857'
            ry='2.11764706'
          />
          <Path d='M8,2 L28.7142857,2' strokeWidth='2' strokeLinecap='round' />
          <Path d='M8,12 L28.7142857,12' strokeWidth='2' strokeLinecap='round' />
          <Path d='M8,22 L28.7142857,22' strokeWidth='2' strokeLinecap='round' />
        </G>
      </G>
    </Svg>
  )
}

export type ProfileListIconProps = {
  width?: number
  fillColor?: string
}
